{% block sw_customer_detail_content_tab_after %}
    {% parent %}

    <sw-tabs-item
        class="sw-customer-detail__tab-contacts"
        :route="{ name: 'sw.customer.detail.contacts', params: { id: $route.params.id } }"
        :title="$tc('TopdataContactLoginSW6.admin.contactsTabTitle')"
    >
        {{ $tc('TopdataContactLoginSW6.admin.contactsTabTitle') }}
    </sw-tabs-item>
{% endblock %}